//Filtering operation handler
export const Filter = {
  //handles filter based on date
  filterOnDateData(emitFilterParams: any, data: any[]) {
    let filterParams = emitFilterParams;
    let betweenAction = filterParams.operationType.toLowerCase();
    let columnName = filterParams.column;
    let value1 = filterParams.firstValue;

    let value2 = filterParams.secondValue;
    if (!value1 && !value2) return data;

    const operation1 = this.getOperation(filterParams.firstSelect);
    const operation2 = this.getOperation(filterParams.secondSelect);

    const merge = betweenAction === 'and';
    return data.filter((a: any) => {
      const reverse1 = operation1.function === 'isSame' ? operation1.reverse : !operation1.reverse;
      const reverse2 = operation2.function === 'isSame' ? operation2.reverse : !operation2.reverse;

      const v1 = a[columnName].trim();
      const compare1 = this.dateCompare(v1, value1, operation1.function, reverse1);

      if (!value2) {
        return compare1;
      }
      let compare2 = this.dateCompare(v1, value2, operation2.function, reverse2);
      return merge ? compare1 && compare2 : compare1 || compare2;
    });
  },
  getOperation(select: string) {
    let opp1 = {function: '', reverse: false};
    switch (select) {
      case 'equal_to': {
        opp1.function = 'isSame';
        break;
      }
      case 'not_equal_to': {
        opp1.function = 'isSame';
        opp1.reverse = true;
        break;
      }
      case 'after_or_equal_to': {
        opp1.function = 'isSameOrAfter';
        opp1.reverse = false;
        break;
      }
      case 'after': {
        opp1.function = 'isSameOrAfter';
        opp1.reverse = true;
        break;
      }
      case 'before_or_equal_to': {
        opp1.function = 'isSameOrBefore';
        opp1.reverse = false;
        break;
      }
      case 'before': {
        opp1.function = 'isSameOrBefore';
        opp1.reverse = true;
        break;
      }
    }
    return opp1;
  },
  //date compare helper functions
  dateCompare(value1: string, value2: string, fnName: any, equal: boolean) {
    const _this: any = this;
    var date1 = new Date(value1);
    var date2 = new Date(value2);
    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);
    const result = _this[fnName](date1, date2, equal);
    return result;
  },
  isSame(date1: Date, date2: Date, not: boolean) {
    return not ? date1.getTime() !== date2.getTime() : date1.getTime() === date2.getTime();
  },
  isSameOrBefore(date1: Date, date2: Date, not: boolean) {
    return not ? date1.getTime() <= date2.getTime() : date1.getTime() < date2.getTime();
  },
  isSameOrAfter(date1: Date, date2: Date, not: boolean) {
    return not ? date1.getTime() >= date2.getTime() : date1.getTime() > date2.getTime();
  },
  //handles string based filters
  filterOnTextData(emitFilterParams: any, data: any[]) {
    let filterParams = emitFilterParams;
    let betweenAction = filterParams.operationType.toLowerCase();
    let columnName = filterParams.column;
    let value1 = filterParams.firstValue.trim().toLowerCase();
    let value2 = filterParams.secondValue.trim().toLowerCase();
    if (!value1 && !value2) return data;

    const operation1 = this.getStringOperation(filterParams.firstSelect);
    const operation2 = this.getStringOperation(filterParams.secondSelect);

    const merge = betweenAction === 'and';
    return data.filter((a: any) => {
      const reverse1 = operation1.reverse;
      const reverse2 = operation2.reverse;
      let value = a[columnName];
      const v1 = value ? value.trim().toLowerCase() : '';
      const compare1 =
        operation1.function !== 'localeCompare'
          ? this.otherOperation(v1, value1, operation1.function, reverse1)
          : this.stringCompare(v1, value1, !reverse1);

      if (!value2) {
        return compare1;
      }
      let compare2 =
        operation2.function !== 'localeCompare'
          ? this.otherOperation(v1, value2, operation2.function, reverse2)
          : this.stringCompare(v1, value2, !reverse2);

      return merge ? compare1 && compare2 : compare1 || compare2;
    });
  },
  //string compare helper functions
  getStringOperation(select: string) {
    let opp1 = {function: '', reverse: false};
    switch (select) {
      case 'equal_to': {
        opp1.function = 'localeCompare';
        break;
      }
      case 'not_equal_to': {
        opp1.function = 'localeCompare';
        opp1.reverse = true;
        break;
      }
      case 'starts_with': {
        opp1.function = 'startsWith';
        opp1.reverse = false;
        break;
      }
      case 'contains': {
        opp1.function = 'includes';
        opp1.reverse = false;
        break;
      }
      case 'not_ontains': {
        opp1.function = 'includes';
        opp1.reverse = true;
        break;
      }
      case 'ends_with': {
        opp1.function = 'endsWith';
        opp1.reverse = false;
        break;
      }
    }
    return opp1;
  },
  stringCompare(value1: string, value2: string, equal: boolean) {
    //
    const result = equal ? value1 === value2 : value1 !== value2;
    return result;
  },
  otherOperation(value1: any, value2: string, fnName: any, not: boolean) {
    return not ? !value1[fnName](value2) : value1[fnName](value2);
  },

  filterOnNumberData(emitFilterParams: any, data: any[]) {
    let filterParams = emitFilterParams;
    let betweenAction = filterParams.operationType.toLowerCase();
    let columnName = filterParams.column;
    let value1 = Number(filterParams.firstValue);
    let value2 = Number(filterParams.secondValue);

    if (!value1 && !value2) return data;
    const operation1 = this.getNumberOperation(filterParams.firstSelect);
    const operation2 = this.getNumberOperation(filterParams.secondSelect);
    const merge = betweenAction === 'and';
    return data.filter((a: any) => {
      const reverse1 = operation1.function === 'isEqual' ? operation1.reverse : !operation1.reverse;
      const reverse2 = operation2.function === 'isEqual' ? operation2.reverse : !operation2.reverse;

      const valueInList = a[columnName];
      const compare1 = this.numberCompare(valueInList, value1, reverse1, operation1.function);

      if (!value2) {
        return compare1;
      }
      const compare2 = this.numberCompare(valueInList, value2, reverse2, operation2.function);
      return merge ? compare1 && compare2 : compare1 || compare2;
    });
  },
  getNumberOperation(select: string) {
    let opp1 = {function: '', reverse: false};
    switch (select) {
      case 'equal_to': {
        opp1.function = 'isEqual';
        opp1.reverse = false;
        break;
      }

      case 'not_equal_to': {
        opp1.function = 'isEqual';
        opp1.reverse = true;
        break;
      }
      case 'greater_than_or_equal_to': {
        opp1.function = 'isGreaterOrEqual';
        break;
      }
      case 'greater_than': {
        opp1.function = 'isGreater';
        break;
      }
      case 'less_than_or_equal_to': {
        opp1.function = 'isLessOrEqual';
        break;
      }
      case 'less_than': {
        opp1.function = 'isLess';
        break;
      }
    }
    return opp1;
  },

  numberCompare(valueInList: number, value1: number, isReverse: boolean, fnName: string) {
    const _this: any = this;
    const result = _this[fnName](value1, valueInList, isReverse);
    return result;
  },

  isEqual(value1: number, valueInList: number, reverse: boolean) {
    return reverse ? valueInList !== value1 : value1 === valueInList;
  },

  isGreaterOrEqual(value1: number, valueInList: number) {
    return value1 <= valueInList;
  },

  isGreater(value1: number, valueInList: number) {
    return value1 < valueInList;
  },

  isLessOrEqual(value1: number, valueInList: number) {
    return value1 >= valueInList;
  },

  isLess(value1: number, valueInList: number) {
    return value1 > valueInList;
  },
};
